import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function DotNet() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="DotNet" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                DotNet
              </h1>
              <p className="text-secondary" id="Language_Para">
                NET Framework is an open-source developer platform you can use
                to create a broad range of applications. This free
                cross-platform framework accepts multiple coding languages and
                features large code libraries that make it easy to build
                applications for mobile devices, desktops, the web and the
                Internet of Things.
                <br />
                NET integrated development environment (IDE) consists of windows
                for visual design of forms, code-editing windows, menus and
                toolbars providing access to commands and features, toolboxes
                containing controls for use on the forms, and windows providing
                properties and information about forms, controls, projects.
                <br />. NET Framework supports more than 60 programming
                languages of which 11 programming languages are designed and
                developed by Microsoft.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
